import config from '@/config'

const method = key => {
  const keys = key.split('.')

  if (keys.length === 1) {
    return config[keys[0]]
  }

  if (keys.length === 2) {
    return config[keys[0]][keys[1]]
  }

  if (keys.length === 3) {
    return config[keys[0]][keys[1]][keys[2]]
  }

  return null
}

export default method
